module.exports = __webpack_public_path__ + "img/942967_D292B5_C76E9E_551A4C-256px.c88a74a6.png";